<template>
    <div>
        <header class="header-mobile">
            <div class="header-mobile__nav">
                <div class="header-mobile__toggle-wrapper">
                    <div class="header-mobile__toggle" v-show="!showSearch" @click="toggleMobileMenu" :class="{
                        'header-mobile__toggle--active': showMobileMenu
                    }">
                        <i :class="{
                            'icon-menu': !showMobileMenu,
                            'icon-close': showMobileMenu
                        }"></i>
                    </div>
                    <div class="header-mobile__toggle" v-show="showSearch" @click="toggleSearch" :class="{
                        'header-mobile__toggle--active': showSearch
                    }">
                        <i :class="{
                            'icon-menu': !showSearch,
                            'icon-close': showSearch
                        }"></i>
                    </div>
                    <div class="header-mobile__logo-wrapper">
                        <a title="Home Page" class="header-mobile__logo" :href="homePageUrl"></a>
                    </div>
                </div>
                <div class="header-mobile__search-toggle" :class="{ 'header-mobile__search-toggle--active': showSearch }"
                    @click="toggleSearch">
                    <i class="icon-search"></i>
                </div>
            </div>
            <Transition>
                <div class="header-mobile__dropdown" v-show="showMobileMenu">
                    <div class="header-mobile__dropdown-primary" v-show="!showSecondaryMenu">
                        <template v-for="item in navigationItems">
                            <div class="header-mobile__primary-item" v-if="item.dropdownComponent" :key="item.key"
                                :item="item" @click="toggleSecondary(item.key)">
                                <span>{{ item.label }}</span>
                                <i class="icon-chevron-down"></i>
                            </div>
                            <a class="header-mobile__primary-item" v-else :key="item.key + 'n'"
                                :href="item.introPrimaryAction.Url">
                                <span>{{ item.label }}</span>
                            </a>
                        </template>
                    </div>
                    <Transition>
                        <div class="header-mobile__dropdown-secondary" v-show="showSecondaryMenu">
                            <div v-for="(item, index) in navigationItems" :key="index">
                                <div class="header-mobile__secondary-inner"
                                    v-if="secondaryMenu !== null && secondaryMenu === item.key">
                                    <div class="header-mobile__secondary-header">
                                        <div class="header-mobile__secondary-back" @click="toggleSecondary(item.key)">
                                            <i class="icon-arrow-left"></i>
                                            <span>{{ item.label }}</span>
                                        </div>
                                        <div class="header-mobile__secondary-intro">
                                            {{ item.introText }}
                                        </div>
                                    </div>
                                    <div class="header-mobile__secondary-component">
                                        <Professionals v-if="item.dropdownComponent === 'Professionals'" />
                                        <Locations v-if="item.dropdownComponent === 'Locations'" />
                                        <ServicesMobile v-if="item.dropdownComponent === 'Services'" />
                                        <Insights v-if="item.dropdownComponent === 'Insights'" />
                                        <About v-if="item.dropdownComponent === 'About'" />
                                    </div>
                                    <div class="header-mobile__secondary-actions"
                                        v-if="item.dropdownComponent !== 'Locations'">
                                        <a class="header-mobile__secondary-action" v-if="item.introPrimaryAction"
                                            :href="item.introPrimaryAction.Url">{{
                                                item.introPrimaryAction.Name }}</a>
                                        <a class="header-mobile__secondary-action" v-if="item.introSecondaryAction"
                                            :href="item.introSecondaryAction.Url">{{ item.introSecondaryAction.Name }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>

                </div>
            </Transition>
            <Transition>
                <div class="header-mobile__search" v-show="showSearch">
                    <div class="header-mobile__search-form">
                        <div class="header-mobile__search-input-wrapper">
                            <form action="/search-results" ref="searchForm">
                                <input type="text" ref="searchInput" required placeholder="Enter name or keyword"
                                    name="query" v-model="searchQuery" @input="runTrigger" />
                                <button title="Search" type="submit">
                                    <i class="icon-search"></i>
                                </button>
                                <div class="search-autocomplete" v-on:mouseleave="showResults = false"
                                    v-if="showResults && results.documents && results.documents.length > 0">
                                    <div class="search-autocomplete__suggestion" @click="runSearch(suggestion.suggestion)"
                                        v-for="(suggestion, index) in results.documents" :key="index">
                                        {{ suggestion.suggestion }}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="header-mobile__visited-clear" @click="clearSearches">Clear Searches</div>
                    <div class="header-mobile__frequent-terms">
                        <h4>Frequently Searched</h4>
                        <ul>
                            <li v-for="frequent in frequentlySearchedTerms" :key="frequent">
                                <a :href="`/search-results?query=${frequent}`">{{ frequent }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="header-mobile__recent-terms" v-if="previousSearches && previousSearches.length > 0">
                        <h4>Previous Searches</h4>
                        <ul>
                            <li v-for="search in previousSearches.slice(0, 5)" :key="search">
                                <a :href="`/search-results?query=${search}`">{{ decode(search) }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </Transition>
        </header>
        <Transition>
            <div class="overlay-backdrop--mobile" @click="showSearch = false" v-if="showSearch"></div>
        </Transition>
    </div>
</template>

<script>
import Locations from './Locations';
import ServicesMobile from './ServicesMobile';
import News from './News';
import Professionals from './Professionals';
import About from './About';
import Insights from './Insights';
import axios from 'axios';

export default {
    props: ["homePageUrl", "frequentlySearchedTerms", "navigationItems"],
    components: {
        Locations,
        ServicesMobile,
        News,
        Professionals,
        About,
        Insights
    },
    data() {
        return {
            showMobileMenu: false,
            showSearch: false,
            showSecondaryMenu: false,
            secondaryMenu: null,
            previousSearches: [],
            recentlyVisited: [],
            timer: null,
            results: {
                documents: []
            },
            searchInput: null,
            searchQuery: "",
            showResults: false,
        }
    },
    computed: {

    },
    mounted() {
        this.previousSearches = JSON.parse(window.localStorage.getItem("previous-searches") ?? "[]").reverse();
        this.getRecentlyVisited();
        this.$nextTick(() => {
            this.$refs.searchInput.focus();
        });

        let self = this;
        document.querySelector("body").addEventListener("click", function (event) {
            self.showResults = false;
        });
    },
    watch: {
        showSearch: function () {
            if (this.showSearch) {
                document.querySelector('body').classList.add("overlay-active--mobile");
            } else {
                document.querySelector('body').classList.remove("overlay-active--mobile");
            }
        }
    },
    methods: {
        decode: function (str) {
            let txt = new DOMParser().parseFromString(str, "text/html");
            return txt.documentElement.textContent;
        },
        getRecentlyVisited: async function () {
            this.recentlyVisited = [];
            try {
                const response = await RecentlyVisited.recentlyVisited();
                this.recentlyVisited = response.content;
                this.loading = false;
            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        },
        clearSearches: function () {
            this.previousSearches = [];
            this.recentlyVisited = [];
            window.localStorage.removeItem("recently-visited");
            window.localStorage.removeItem("previous-searches");
        },
        toggleSearch: function () {
            if (this.showSearch === true) {
                this.showSearch = false;
            } else {
                this.showSearch = true;
                this.showMobileMenu = false;
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            }
        },
        toggleMobileMenu: function () {
            this.showSearch = false;
            this.showMobileMenu = !this.showMobileMenu;

            if (this.showMobileMenu) {
                document.querySelector('body').classList.add("overlay-active--mobile");
            } else {
                document.querySelector('body').classList.remove("overlay-active--mobile");
            }

            setTimeout(() => {
                this.showSecondaryMenu = false;
                this.secondaryMenu = null;
            }, 500);
        },
        toggleSecondary: function (key) {
            if (this.showSecondaryMenu === true) {
                this.showSecondaryMenu = false;
                this.secondaryMenu = null;
            } else {
                this.showSecondaryMenu = true;
                this.secondaryMenu = key;
            }
        },
        runSearch(suggestion) {
            this.searchQuery = suggestion;
            this.$nextTick(() => {
                this.$refs.searchForm.submit();
            });
        },
        runTrigger() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.searchQuery && this.searchQuery.length > 3) {
                    axios.post("https://o-melveny-site-search.ent.us-central1.gcp.cloud.es.io/api/as/v1/engines/umbraco-search-production/query_suggestion", {
                        query: this.searchQuery,
                        types: {
                            documents: {
                                fields: [
                                    "title",
                                    "full_name",
                                    "professional_languages",
                                    "professional_education",
                                    "professional_admissions",
                                    "professional_honors",
                                    "professional_activities",
                                    "professional_corporate_experience",
                                ]
                            }
                        },
                        size: 5
                    }, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer search-p5qfzquhtw1okw3mibb219ja'
                        }
                    })
                        .then((response) => {
                            this.results = response.data.results;
                            this.showResults = true;
                        })
                        .catch((err) => {
                            this.showResults = false;
                        });
                }
            }, 100)


        }
    }
}
</script>

<style scoped>
/* we will explain what these classes do next */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>